// no result
import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  useMemo,
  forwardRef,
} from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { Iconfont } from '@/lib';
import g_styles from '@/components/public.style';
import { makeStyles } from 'tss-react/mui';
import { CircularProgress } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  ...g_styles(theme),
}));

const NoresultRC = (props, ref) => {
  const { classes, cx } = useStyles();
  const intl = useIntl();
  const { className, loading } = props;

  return loading ? (
    <span className={cx(classes.g_noresult, className)}>
      <CircularProgress size={14} />
    </span>
  ) : (
    <span className={cx(classes.g_noresult, className)}>
      {intl.formatMessage({ id: 'No record' })}
    </span>
  );
};

export default forwardRef(NoresultRC);
